// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".claimItemInformation-inputs-2Nl {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 30px;\n    margin-bottom: 80px;\n}\n\n.claimItemInformation-addItem-Y-D {\n    margin-bottom: 45px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputs": "claimItemInformation-inputs-2Nl",
	"addItem": "claimItemInformation-addItem-Y-D"
};
export default ___CSS_LOADER_EXPORT___;
